"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.6 5.336a.3.3 0 0 0-.455-.257l-5.29 3.195H5.7a1.3 1.3 0 0 0-1.3 1.3v3.449a1.3 1.3 0 0 0 1.3 1.3h8.155l5.29 3.195a.3.3 0 0 0 .455-.257zM18.421 3.88C19.554 3.196 21 4.012 21 5.336V17.26c0 1.324-1.446 2.14-2.579 1.456l-4.956-2.994H5.7a2.7 2.7 0 0 1-2.7-2.7V9.574a2.7 2.7 0 0 1 2.7-2.7h7.765z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.61 15.596V7.86h1.4v7.735zm-5.36 3.569-1.996-4.123 1.26-.61 1.996 4.122a.73.73 0 0 0 1.317-.627L8.75 15.62l1.268-.593 1.078 2.307a2.13 2.13 0 0 1-3.845 1.83",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MegaphoneIcon24.js.map